import { Link } from "react-router-dom";
import { ScrollText, Shield, UserCog, Users } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import { WidgetFrame } from "../WidgetFrame";
import type { DashboardWidgetProps } from "../types";

const SHORTCUTS: { to: string; label: string; icon: LucideIcon }[] = [
  { to: "/admin/users", label: "Users & roles", icon: Users },
  { to: "/admin/portal-accounts", label: "Portal accounts", icon: UserCog },
  { to: "/admin/roles", label: "Role catalog", icon: Shield },
  { to: "/admin/audit", label: "Audit log", icon: ScrollText },
];

export function UserManagementShortcutsWidget({ widget }: DashboardWidgetProps) {
  return (
    <WidgetFrame title={widget.title} subtitle={widget.subtitle}>
      <div className="grid grid-cols-2 gap-space-2">
        {SHORTCUTS.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="flex items-center gap-space-2 rounded-md border border-border-light px-space-3 py-space-2 text-small font-semibold text-onyx hover:border-gold hover:bg-white-warm"
          >
            <Icon size={16} strokeWidth={1.5} className="text-gold-shadow shrink-0" aria-hidden />
            {label}
          </Link>
        ))}
      </div>
    </WidgetFrame>
  );
}
